<template lang="pug">
  .UsersNames
    .mx-5.px-5
      .mt-5.transition.max-w-sm.mx-auto.bg-white.rounded-xl.shadow-bx-small-sm.p-5.text-center.pt-3
        h2.text-primary.text-2xl.m-0.font-semibold Agendamiento de citas
        div
          p.mt-1.text-info_color.m-0 Pedimos disculpas, el servicio de agendamiento no esta disponible en este momento. Por favor intente mas tarde.
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: "Page500",
  data() {
    return {
      disabledContinue: false,
    };
  },
  mounted(){
    if(!this.maintenance) this.$router.push({ path: "/", });
  },
  components: {
  },
  computed: {
    ...mapState({
      maintenance: (state) => state.environment.environment.maintenance
    }),
  },
  methods: {
  },
};
</script>

<style scoped>

</style>